/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mAssets.vue?vue&type=template&id=324888ba&scoped=true"
import script from "./mAssets.vue?vue&type=script&lang=js"
export * from "./mAssets.vue?vue&type=script&lang=js"
import style0 from "./mAssets.vue?vue&type=style&index=0&id=324888ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324888ba",
  null
  
)

export default component.exports